export default "__VITE_ASSET__CQKMYvkb__"